<!-- 项目管理 - 项目列表 - 详情弹框 -->
<template>
    <custom-modal
        width="824px"
        :title="modalTitle"
        :visible="visible"
        class="project-perfect-info-modal"
        @on-close="handleClose"
    >
        <modal-content :record="record" @on-after-confirm="handleAfterConfirm" />
        <template slot="customFooter">
            <a-button type="primary" @click="handleOk">
                进入详情
            </a-button>
        </template>
    </custom-modal>
</template>

<script>
import { Button as AButton } from 'ant-design-vue'
import CustomModal from '@components/CustomModal'

import ModalContent from './Content'

import openNewPageEventStrategy from '@mixins/createPage/event/openNewPageEvent'

export default {
    name: 'ProjectPerfectInfoModal',
    components: {
        AButton,
        CustomModal,
        ModalContent
    },
    props: {
        visible: Boolean,
        record: {
            type: Object,
            required: true
        },
        event: {
            type: Object,
            default: () => {}
        },
        params: {
            type: Object,
            default: () => {}
        }
    },
    computed: {
        // 弹框标题
        modalTitle() {
            return `温馨提示`
        }
    },
    methods: {
        handleClose() {
            this.$emit('on-close')
        },
        handleAfterConfirm() {
            this.handleClose()
            this.$emit('on-ok')
        },
        handleOk() {
            const { eventCode } = this.event
            let openNewPage = openNewPageEventStrategy[eventCode] || openNewPageEventStrategy.default
            openNewPage.apply(this, [this.event, this.record, this.params])
        }
    }
}
</script>

<style lang="scss">
    .ant-modal-title {
        text-align: center;
    }
    .project-perfect-info-modal {
        .ant-btn {
            width: 100%;
        }
    }
</style>
